import { Action } from '@ngrx/store';
import { BpmnModelerData } from '@ispm-client/modules/bpmn-modeler/models/bpmn-modeler-data';

export enum BpmnHooksActionTypes {
  DIRECT_UPDATE_BPMN_MODELER_DATA = '[bpmn process creator] Direct Update Bpmn Modeler Data'
}

export class DirectUpdateBpmnModelerDataAction implements Action {
  readonly type = BpmnHooksActionTypes.DIRECT_UPDATE_BPMN_MODELER_DATA;
  constructor(public payload: { bpmnModelerData: BpmnModelerData}) { }
}

export type BpmnHooksAction = DirectUpdateBpmnModelerDataAction;
